import { render, staticRenderFns } from "./AttentionPage.vue?vue&type=template&id=47b3383f"
import script from "./AttentionPage.vue?vue&type=script&lang=js"
export * from "./AttentionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports